import { IDropDownListProps } from "../../../../component/common/CommonDropdown/dropdown/DropDown.d";
import { TFilterDropDownData } from "../../../../fixtures/data-fixtures/ComponentConfigFixtures";
import { IXYChartConfig } from "../../../../component/common/XYChart/XYChart.d";
import { ITableConfig } from "../../../../component/common/CommonTable/CommonTable.d";
import { IGraphLegend } from "../../../../component/common/GraphLegend/GraphLegend";
export interface ITabsComponentProps {
    config: ITabsViewConfig;
    data: any;
	filters: ITabsComponentFilter[];
	syncTime: Date;
    onFilterChange: (selectedFilters: Array<ISelectedFilter>) => Promise<any>;
}

export type TActionPayload = IInitTabsComponentPayload | ITabUpdatePayload | ISubTabUpdatePayload | ISetFilterPayload | IToggleFilterPayload | IDataUpdatePayload | ISyncPayload;

export interface IInitTabsComponentPayload {
	state: ITabsComponentState
}

export interface ITabUpdatePayload {
	newTabIndex: number;
}

export interface ISubTabUpdatePayload {
	newSubTabIndex: number;
}

export interface ISetFilterPayload {
	selected: Array<TFilterDropDownData>;
	index: number;
	displayValue: string;
}

export interface IToggleFilterPayload {
	filter: ITabsComponentFilter;
	index: number;
}

export interface IDataUpdatePayload {
    data: any
}

export interface ISyncPayload {
	filters: Array<ITabsComponentFilter>;
	data: any;
}

export enum Actions {
	INIT_STATE = 'INIT_STATE',
	TAB_UPDATE = 'TAB_UPDATE',
	SUBTAB_UPDATE = 'SUBTAB_UPDATE',
	DATA_UPDATE = 'DATA_UPDATE',
	SET_SELECTED_FILTER = 'SET_SELECTED_FILTER',
	SET_FILTER = 'SET_FILTER',
	SYNC_COMPONENT = 'SYNC_COMPONENT',
	CLEAR_ALL_FILTER = 'CLEAR_ALL_FILTER'
}

export interface ITabsComponentFilter {
	key: string;
	multiSelection: boolean;
	displayValue: string;
	config: IDropDownListProps;
}

export interface ITabsComponentState {
	tabs: ITabStructure[];
	title: string;
	activeTabIndex: number;
	activeSubTabIndex: number;
	componentData: {};
	filters: ITabsComponentFilter[];
    activeConfig: {};
    data: {};
}

export interface IComponentActionProps {
	action: Actions;
	payload: object;
}

export interface ITabsViewConfig {
	componentHeight?: string;
	title: string;
	tabs: ITabStructure[];
}

export interface ISubTabStructure {
	title: string;
	header?: string | IValueStructure;
	componentType: TComponentType;
	data_path?: string;
	iconName: string;
	componentConfig: IXYChartConfig | ITableConfig;
	legendsInfo?: ILegendsInfo;
}

export interface ILegendsInfo {
	legends: Array<IGraphLegend>;
}
export interface IValueStructure {
	prefixValue?: string | number;
	prefixprop?: string;
	value?: string | number;
	prop?: string;
	suffixValue?: string | number;
	suffixProp?: string;
	style?: string;
}

export interface ITabStructure {
	title: string;
	data_path?: string;
	subTabs: ISubTabStructure[];
}

export type TComponentType =  "XY_CHART" | "TABLE";

export interface IDetailViewFilterProps {
	filter: ITabsComponentFilter;
	onFilterClose: (ITabsComponentFilter) => void;
}

export interface ISelectedFilter {
	key: string;
	values: Array<string>;
}

